import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UnbanUser, Summary } from './state.types';

export const initialUnbanUser: UnbanUser = {
    feedName: '',
    userId: '',
    summary: {} as Summary,
    loading: false,
};

const unbanUser = createSlice({
    name: 'unbanUser',
    initialState: initialUnbanUser,
    reducers: {
        setFeedName: (state, action: PayloadAction<string>) => {
            state.feedName = action.payload;
        },
        setUserId: (state, action: PayloadAction<string>) => {
            state.userId = action.payload;
        },
        setSummary: (state, action: PayloadAction<Summary>) => {
            state.summary = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const { setFeedName, setUserId, setSummary, setLoading } = unbanUser.actions;


export default unbanUser.reducer;
